import { type FC, type ReactNode } from "react";

import styled from "@emotion/styled";
import { Spacing, Spinner } from "@snapchat/snap-design-system";

import emptySearchSvg from "@app-assets/svg/empty-search.svg";

import { useLensFilterByStatus } from "../../lenses/hooks";
import { Flexbox } from "../../shared/components";

import { CardTitle } from "./Card";

interface LoadingContainerProps {
    loading: boolean;
    noResults: boolean;
    height: number | string;
    addMarginTop?: boolean;
    children?: ReactNode;
}

const SpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const EmptySearchIcon = styled.img`
    width: 131.7px;
    height: 96px;
`;

const TopSpacer = styled.div`
    margin-top: ${Spacing.SM}px;
`;

export const SearchContainer: FC<LoadingContainerProps> = ({
    children,
    height,
    loading,
    noResults,
    addMarginTop = false,
}) => {
    const { filterIsEmpty } = useLensFilterByStatus();

    if (loading) {
        return (
            <SpinnerContainer style={{ height: height }}>
                <Spinner />
            </SpinnerContainer>
        );
    }
    if (noResults || filterIsEmpty) {
        return (
            <Flexbox alignItems="center" justifyContent="center" flexDirection="column" style={{ height: height }}>
                <EmptySearchIcon alt="Empty search icon" src={emptySearchSvg} />
                <CardTitle>No Results</CardTitle>
            </Flexbox>
        );
    }
    return (
        <>
            {addMarginTop && <TopSpacer />}
            {children}
        </>
    );
};
